import {RootStore, store} from '../redux/store';

export default function getCurrentUnitLink() {
  const allState: RootStore = store.getState();
  const allLinks = allState.units.unitLinks;
  const currentLink = allLinks.find((link) => link.isDefault === true);

  return currentLink ?? null;
}
